<template>
  <!-- 指引 -->
  <div class="guide">
    <div class="masking"></div>
    <div class="mask-block"><img class="mask-img" src="../../assets/img/guide/guide4.png" alt=""></div>
    <div class="popu-block">
      <div class="block">
        <div class="popu-head flex-between-center">
          <div class="title">搜索菜单</div>
          <div class="close" @click="closeGuied">
            <img
              class="close-icon"
              src="../../assets/img/close.png"
              alt=""
            />
          </div>
        </div>
        <div class="guide-msg">您可在此通过关键字搜索您需要使用的功能菜单</div>
        <div class="guide-button flex-between-center">
          <div class="step">(1/4)</div>
          <div class="next-button flex-center-center" @click="next">下一步</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
import api2 from "../../modules/projectA/api/user";
export default {
  props: [],
  data() {
    return {};
  },
  watch: {},
  methods: {
    ...mapMutations(["SHOW_LIB"]),
    next() {
      this.$parent.next();
    },
    async closeGuied() {
      await api2.noviceGuidanceClose().then((res) => {
        this.SHOW_LIB("-1");
      });
    },
  },
  mounted: function () {},
};
</script>

<style lang="scss" scoped>
.guide {
  position: relative;
  .mask-block{
    position: absolute;
    z-index: 99999;
    top: 50px;
    left: 0px;
    .mask-img{
      width: 120px;
    }
  }
  .popu-block {
    width: 100%;
    margin: 0 auto;
    position: relative;
    .block {
      .flex-between-center {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .flex-center-center {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .popu-head {
        .title {
          color: #333333;
          font-size: 18px;
          font-weight: 500;
        }
        .close {
          cursor: pointer;
          .close-icon {
            width: 12px;
            height: 12px;
            display: block;
          }
        }
      }
      .guide-msg {
        color: #333333;
        font-size: 14px;
        font-weight: 350px;
        margin-top: 10px;
      }
      .guide-button {
        position: absolute;
        bottom: 20px;
        width: 380px;
        .step {
          color: #999999;
          font-size: 16px;
        }
        .next-button {
          cursor: pointer;
          background: #2587ff;
          color: #ffffff;
          width: 80px;
          height: 30px;
          font-size:14px;
        }
        .next-button:hover{
          background: #6AA1FF;
        }
        .next-button:active{
          background: #0064C8;
        }
      }
      z-index: 999999 !important;
      background: #ffffff;
      margin-bottom: 0;
      position: absolute;
      left: 140px !important;
      top: -40px;
      width: 420px;
      height: 170px;
      margin-top: 48px !important;
      border-radius: 10px;
      padding: 20px;
      &::before {
        content: "";
        position: absolute;
        left: -15px;
        top: 60px;
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 10px solid #fff;
        transform: rotate(-90deg);
      }
    }
  }

  .masking {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1001;
  }
}
</style>
